module.exports = __webpack_public_path__ + "img/anxiety-icon-2.4f195880.svg";